<template lang="html">
	<div class="vue-local">
		<div class="row center-v">
			<div class="cols s_24 m_24">
				<div class="container">
					<h1 class="header">{{header}}</h1>
					<p class="statusError" v-if='data.server_response'>{{data.server_response.message}}</p>


					<template v-for='(field, i) in fields'>
						<!-- если есть селект, подключаем его -->
						<template v-if='field.type == "select"'>
							<span class="label">{{field.label}}</span>
							<dropdown-multiple
								v-if="field.multiple == true"
								:name='field.name'
								:options='field.options'
								:placeholder='field.placeholder'
								@changed='ddmultipleChanged'
							/>
							<dropdown-write
								v-else-if="field.multiple == false"
								:name='field.name'
								:options='field.options'
								:placeholder='field.placeholder'
								@changed='ddwriteChanged'
							/>
							<dropdown
								v-else
								:data='field'
								:name='field.name'
								:ref='`input-${i}:${field.type}`'
								@changed='dropdownChange'
							/>

						</template>

							<!-- то же самое с радиокнопками -->
							<template v-else-if='field.type == "radiogroup"'>
								<div class="containerRadio">
									<label class="BlockRadio">
										<span class="label">{{field.label}}</span>
										<radiogroup  class="radiogroup"
											:name='field.name'
											:group='field.fields'
											:required='field.required'
											:ref='`input-${i}:${field.type}`'
											:validator='field.validator || ""'
											@RADIOGROUP_CHANGED='radioWasChanged'
										/>
									</label>
								</div>
							</template>

						<template v-else-if='field.type == "textarea"'>
							<span class="label" >
								{{field.label}}
							</span>
							<v-textarea
								:key='`input-${i}:${field.type}`'
								:data='field'
								@changedText='textareaChange'
								:ref='`input-${i}:${field.type}`'
							/>

							</template>


						<!-- и все инпуты типа text, tel, mail, data, password... -->
						<template v-else>
							<span class="label" >
								{{field.label}}
							</span>

							<template v-if='field.type == "checkbox"'>
								<span class="label">{{field.label}}</span>
								<label class="BlockCheckbox">
									<vinput
										:key='`input-${i}:${field.type}`'
										:type='field.type'
										:name='field.name'
										:value='field.value'
										:placeholder='field.placeholder || ""'
										:required='field.required'
										:check='field.check ? field.check : ""'
										:validator='field.validator || ""'
										:ref='`input-${i}:${field.type}`'
										v-if='field.type == "checkbox"'
									/>
									<span class="label" v-html='field.text'></span>
								</label>

							</template>

							<vinput
								v-else
								:key='`input-${i}:${field.type}`'
								:type='field.type'
								:name='field.name'
								:value='field.value'
								:text='field.text'
								:repeat='field.repeat'
								:required='field.required'
								:placeholder='field.placeholder'
								:validator='field.validator || ""'
								:identic='field.identic || ""'
								:ref='`input-${i}:${field.type}`'
							/>
						</template>
					</template>

					<!-- подключаем сабмит -->
					<div class="containerButton">
						<vsubmit @COMPLETE='onComplete' @INCOMPLETE='onIncomplete'>
							<div class="buttonStep1">
								{{data.button}}
							</div>
						</vsubmit>
					</div>

				</div>
			</div>
		</div>





		<grecaptcha
			:request='request'
			:payload='payload'
			@SENDFORM='onRecaptchaSubmit'
		/>

	</div>
</template>


<script>
const objectMerge = require('object-merge');

module.exports = {
	props: ['data'],

	components: {
		vinput: 	require('./elements/input.vue'),
		vsubmit: require('./elements/submit.vue'),
		grecaptcha: require('./elements/grecaptcha.vue'),
		dropdown: require('./elements/dropdown.vue'),
		'v-textarea': require('./elements/textarea.vue'),
		'dropdown-write': require('./elements/dropdown-write.vue'),
		'dropdown-multiple': require('./elements/dropdown-multiple.vue'),
		radiogroup: require('./elements/radiogroup.vue')
	},

	data() {
		return {
			payload: {},
			radio: {},
			checkbox: {},
			dropdowns: {},
			ddmultiple: {},
			ddwrite: {},
			country_code: '',
			textarea: {},

			showNewPassportFields: false
		}
	},

	computed: {
		header () {
			return this.data ? this.data.header : {};
		},

		fields() {
			return this.data ? this.data.fields : {};
		},

		error() {
			return this.data.server_response ? this.data.server_response.fields : {};
		},

		request() {
			return this.data ? this.data.request : {};
		}
	},

	watch: {
		error() {
			if(this.data.server_response){
				// console.log(this.data.server_response)
				setTimeout(() => {
					if(this.data.server_response != 'undefined'){
						// console.log(this.data.server_response );
						if(this.data.server_response.fields){
							for (var i = 0; i < this.data.server_response.fields.length; i++) {
								var el = this.data.server_response.fields[i];
								document.querySelector('[name='+ el +']').parentNode.classList.add('serverError');
							}
							document.querySelector('.form-submit').classList.remove('load');
						}
					}
				}, 1000);
			}
		}
	},

	methods: {
		radioWasChanged(payload) {
			this.radio = objectMerge(this.radio, payload);
		},
		onCheckboxChange(e, f) {
			// console.log(e.target.checked);
			this.showNewPassportFields = e.target.checked;
		},
		ddwriteChanged(payload, val) {
			this.ddwrite = payload;
			this.country_code = val;
			// console.log(this.ddwrite);
		},
		ddmultipleChanged(payload) {
			this.ddmultiple = payload;
			// console.log(this.ddmultiple);
		},

		onRecaptchaSubmit(payload) {
			this.$emit('SENDFORM', payload);
		},
		onComplete(payload) {
			// alert('complete!');
			this.payload = objectMerge(payload, this.dropdowns, this.payload, this.ddwrite, this.ddmultiple, this.radio);
		},
		dropdownChange(payload) {

			this.dropdowns[payload.name] = payload.value;
		},
		textareaChange(payload) {
			// console.log(this.textarea);
			this.textarea[payload.name] = payload.value;
		},
		onIncomplete(el) {
			// console.log(el);
			// $.fancybox(window.YAMASTERS_FRONTEND.validator.messages.incomplete, {
			// 	afterClose() {
			// 		el.focus();
			// 	}
			// });
			// setTimeout(() => {
			// 	$.fancybox.close();
			// }, 2000)
		}
	},


}
</script>

<style lang="scss">
@import "SCSS/wanted";
	.VueForm.default{
		.vue-local{
			// background: white;
			color: black;
			margin-top: 80px;
			.container{
				.header{
					color: #1e1e1e;
					font-size: rem(22);
					font-family: $ProximaNova_light;
					margin-bottom: 20px;
				}
				.statusError{
					display: block;
					background-color: #DD4B39;
					color: white;
					padding: 0 10px;
					line-height: 27px;
					margin-bottom: 15px;
					border-radius: 5px;
				}
				.radiogroup{
					position: relative;
					&:before{
						content: '';
						display: flex;
						position: absolute;
						top: calc(50% - 11px);
						right: 5px;
						font-size: 14px;
						width: 25px;
						align-items: center;
						justify-content: center;
						z-index: 1;
						pointer-events: none;
						opacity: 0;
						transition: all 300ms ease;
					}
					&.error{
						&:before{
							content: "\F00D";
							font-family: "FontAwesome";
							text-rendering: auto;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
							opacity: 1;
							color: red;
						}
					}
				}
				.BlockRadio{
					.label{
						padding-top: 15px;
						padding-bottom: 15px;
						display: block;
					}
				}
				.label {
					color: #b1b1b1;
					font-size: rem(14);
					-webkit-user-select: none;
					-moz-user-select: none;
					-ms-user-select: none;
					clear: both;
				}
				.male{
					[type="radio"] + span{
						&:before{
							width: 46px!important;
							height: 46px!important;
							background-image: url('../img/man.png')!important;
							border: none!important;
							filter: grayscale(100%);
						}
					}
					.text{
						opacity: 0;
						font-size: 0px;
						@include m_up{
							font-size: 16px;
							opacity: 1;
						};
					}
					[type="radio"]:checked + span, {
						&:before{
							filter: grayscale(0);
						}
					}
					&:hover{
						[type="radio"] + span, {
							&:before{
								filter: grayscale(0);
							}
						}
					}
				}
				.famale{
					[type="radio"] + span{
						&:before{
							width: 46px!important;
							height: 46px!important;
							background-image: url('../img/girl.png')!important;
							border: none!important;
							filter: grayscale(100%);
						}
					}
					[type="radio"]:checked + span{
						&:before{
							filter: grayscale(0);
						}
					}
					&:hover{
						[type="radio"] + span, {
							&:before{
								filter: grayscale(0);
							}
						}
					}
					.text{
						display: none!important;
						@include m_up{
							display: inline!important;
						};
					}
				}
				.editInfo{
					margin: auto;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-top: 32px;
					margin-bottom: 5px;
					height: 55px;
					border-radius: 25px;
					background-color: #e6b012;
					color: #21293b;
					border: 1px solid #e6b012;
					box-shadow: 0px 10px 25px 5px rgba(0, 0, 0, 0.2);
					transition: all .5s ease-out 0s;
					cursor: pointer;
					&:hover{
						background-color: white;
					}
				}
				.containerButton{
					margin: auto;
					width: 224px;
					margin-top: 32px;
					margin-bottom: 5px;
					background: transparent;
				}
				.BlockCheckbox {
					cursor: pointer;
					display: flex;
					.checkbox {
						display: none!important;
					}
					.focus-bg{
						display: none;
					}
					.checkbox-custom {
						position: relative;
						width: 16px;
						height: 16px;
						border: 1px solid #b1b1b1;
						border-radius: 3px;
					}
					.v_field{
						margin-right: 10px;
						input{
							margin-top: 3px;
						}
					}
					.checkbox-custom,
					.label {
						display: block;
						vertical-align: middle;
						color: #282828;
						margin-top: 15px;
						margin-bottom: -2px;
						font-size: rem(14);
						line-height: rem(18);
						a{
							color: #e6b012;
						}
					}
					.checkbox:checked + .checkbox-custom::before {
						content: "";
						display: block;
						position: absolute;
						top: 2px;
						right: 2px;
						bottom: 2px;
						left: 2px;
						background: #413548;
						border-radius: 2px;
					}
				}

			}
		}
	}
</style>



// WEBPACK FOOTER //
// default.vue?30a8eebe